import React, { useEffect, useState } from "react";
import { profileProps } from "./types";
import styles from "./components/profileComponent/profileComp.module.scss";
import { placeholder } from "../../constants/images";
import Icon from "../../components/Icon";
import Button from "../../components/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  EmailShareButton,
  EmailIcon,
  TwitterShareButton,
  TwitterIcon,
  FacebookShareButton,
  LinkedinShareButton,
  LinkedinIcon,
  WhatsappIcon,
  TelegramIcon,
  WhatsappShareButton,
  TelegramShareButton,
  FacebookIcon,
} from "react-share";
import { toast } from "sonner";
import axios from "axios";
import BasicInfo from "./components/profileComponent/BasicInfo";
import WorkExperience from "./components/profileComponent/WorkExperience";
import Education from "./components/profileComponent/Education";
import AboutMe from "./components/profileComponent/AboutMe";
import Certifications from "./components/profileComponent/Certifications";
import { useProfile } from "../../context/ProfileContext";

//!userProfile component
const UserProfile: React.FC<profileProps> = ({ handleImage, preview }) => {
  const {
    unSaved,
    setUnsaved,
    profileInfo,
    handleChange,
    handleFocus,
    updatedField,
    current,
    handleSubmit,
  } = useProfile();

  const [profilelink, setProfileLink] = useState<string>("");
  const [share, setShare] = useState<boolean>(false);
  const [copy, setCopy] = useState<boolean>(false);

  const getProfileLink = async () => {
    const token = localStorage.getItem("token");
    const id = localStorage.getItem("id");
    const url = `https://core.pluritongues.com/teachers/${id}`;

    try {
      let response = await axios.get(`${url}/profile-url`, {
        headers: {
          Authorization: `bearer ${token}`,
        },
      });

      if (response?.status === 200) {
        setProfileLink(response?.data?.result?.profileUrl);
      }
    } catch (error) {
      toast.error("Failed to get profile link", {
        richColors: true,
      });
    }
  };

  useEffect(() => {
    getProfileLink();
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setCopy(false);
    }, 6000);
  }, [copy]);

  const getRole = () => {
    return localStorage.getItem("Role");
  };

  return (
    <div className={styles.ProfContainer}>
      {share && (
        <>
          <div className={styles.overLay}></div>
          <div className={styles.shareModal}>
            <p className={styles.shareHeader}>Share your profile</p>
            <div
              className={styles.closed}
              onClick={() => {
                setShare(false);
              }}
            >
              <Icon name="close" />
            </div>
            <div className={styles.linkBox}>
              <p>{profilelink}</p>
            </div>
            <div className={styles.shareable}>
              <FacebookShareButton url={profilelink}>
                <FacebookIcon size={32} round />
              </FacebookShareButton>
              <TwitterShareButton url={profilelink}>
                <TwitterIcon size={32} round />
              </TwitterShareButton>
              <WhatsappShareButton url={profilelink}>
                <WhatsappIcon size={32} round />
              </WhatsappShareButton>
              <LinkedinShareButton url={profilelink}>
                <LinkedinIcon size={32} round />
              </LinkedinShareButton>
              <EmailShareButton url={profilelink}>
                <EmailIcon size={32} round />
              </EmailShareButton>
              <TelegramShareButton url={profilelink}>
                <TelegramIcon size={32} round />
              </TelegramShareButton>
            </div>
          </div>
        </>
      )}

      {getRole()?.toLocaleLowerCase() === "teacher" && (
        <div className={`${styles.InfoContainer}`}>
          <div className={styles.Header}>
            <h3>Profile Link </h3>
          </div>
          <div className={`${styles.inputContainer}`}>
            <input
              id="profileLink"
              type="text"
              className={`${styles.basicInputs}`}
              readOnly
              name="profileLink"
              value={profilelink}
              placeholder="profile link"
            />
            <div>
              <div className={styles.shareButton}>
                <div
                  onClick={() =>
                    navigator.clipboard
                      .writeText(profilelink)
                      .then(() => setCopy(true))
                  }
                >
                  {copy ? (
                    <p>copied</p>
                  ) : (
                    <Icon name="copy" height={70} width={70} />
                  )}
                </div>
                <div
                  onClick={() => {
                    setShare(!share);
                  }}
                >
                  <Icon name="external" height={25} width={25} />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className={styles.InfoContainer}>
        <div className={styles.picCont}>
          <div>
            {preview ? (
              <img alt="" src={preview} className="placeholderProfilePicture" />
            ) : (
              <img
                alt=""
                src={profileInfo?.dpUrl ?? placeholder}
                className="placeholderProfilePicture"
              />
            )}
          </div>
          <div className={styles.fileUpload}>
            <p>
              This will be displayed to other users when they view your profile.{" "}
            </p>
            <Button
              variant="neutral"
              className={styles.imgBtn}
              onClick={() => {
                (document.querySelector("#img") as HTMLInputElement)?.click();
              }}
            >
              <div className={styles.btnDiv}>
                <FontAwesomeIcon
                  className="cameraIcon"
                  icon={["fas", "camera"]}
                />
                <p>Upload Photo</p>
              </div>

              <input
                id="img"
                type="file"
                name="image"
                accept="image/*"
                onChange={handleImage}
                placeholder="addImage "
                className={styles.imgCont}
              />
            </Button>
            <div>
              <p>Max size: 5MB</p>
              <p>Png or Jpg Format.</p>
            </div>
          </div>
        </div>
      </div>
      {getRole()?.toLocaleLowerCase() === "teacher" && (
        <div className={styles.InfoContainer}>
          <div className={styles.introVideo}>
            {profileInfo?.youtubeUrl ? (
              <iframe
                className={styles.video}
                src={`https://www.youtube.com/embed/${
                  profileInfo?.youtubeUrl.split("=")[1]
                }`}
                title="Introduction Video"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            ) : (
              <p>No video provided. Add a video URL below.</p>
            )}

            <div
              className={`${styles.inputContainer}  ${
                updatedField?.fieldName === "youtube"
                  ? styles.editingField
                  : null
              }`}
            >
              <input
                type="text"
                name="youtubeUrl"
                className={`${styles.basicInputs}`}
                value={profileInfo?.youtubeUrl}
                placeholder="Add Link to introductory Video"
                onChange={handleChange}
                onFocus={() => {
                  return handleFocus("youtube", "Introduction Video");
                }}
              />

              <div>
                <Icon
                  name="edit"
                  width={20}
                  height={20}
                  className={styles.edits}
                />
              </div>
            </div>
            {(current?.fieldName === "youtube" ||
              updatedField?.fieldName === "youtube") && (
              <div className={styles.saves}>
                <button
                  className={styles.save}
                  onClick={(e: any) => handleSubmit(e, "youtube")}
                >
                  Save
                </button>
                <button className={styles.discard}>Discard</button>
              </div>
            )}
          </div>
        </div>
      )}

      <BasicInfo />
      {getRole()?.toLocaleLowerCase() === "teacher" && <WorkExperience />}
      {getRole()?.toLocaleLowerCase() === "teacher" && <Education />}
      <AboutMe />
      {getRole()?.toLocaleLowerCase() === "teacher" && <Certifications />}

      {unSaved && (
        <>
          <div className={styles.overLay}></div>
          <div className={styles.dialogs}>
            <h4>Unsaved Changes</h4>
            <p>
              You have not saved the changes you made in {current?.section}{" "}
              section
            </p>

            <div className={styles.dialogBtn} onClick={() => setUnsaved(false)}>
              <button className={styles.btn2}>close</button>
            </div>
          </div>
        </>
      )}
    </div>
    // </div>
  );
};

export default UserProfile;
